module.exports = __webpack_public_path__ + "img/error.ed3dabe7.svg";